import { createSlice } from '@reduxjs/toolkit';

import { RiskSupplementWarningType } from '@models/riskSupplementWarningType';

import { handleGetHighRiskSupplementWarningTypes } from './actions';
import { IWarningTypesState } from './slice.interface';

const initialState: IWarningTypesState = {
  data: null,
  isLoading: false,
  isReady: false,
  error: false,
};

export const warningTypesSlice = createSlice({
  name: 'warning-types',
  initialState,
  reducers: {
    removeWarningTypes: state => {
      state.data = null;
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleGetHighRiskSupplementWarningTypes.pending,
        (state: IWarningTypesState, action) => {
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(
        handleGetHighRiskSupplementWarningTypes.rejected,
        (state: IWarningTypesState, action) => {
          state.isLoading = false;
          state.error = true;
        },
      )
      .addCase(
        handleGetHighRiskSupplementWarningTypes.fulfilled,
        (state: IWarningTypesState, action) => {
          state.isLoading = false;
          state.isReady = true;
          state.data = Array.isArray(action?.payload?.data)
            ? action.payload.data.map(item => new RiskSupplementWarningType(item))
            : null;
        },
      );
  },
});

export const { removeWarningTypes } = warningTypesSlice.actions;

export default warningTypesSlice.reducer;
